// import React, { useEffect, useState } from 'react';
// import SelectDropdown from '../../Shared/SelectDropdown/index';
// import SweetAlert from '../../Shared/Notification';
// import OptionModal from '../../Modals/OptionModal';
// import FillSupplierModal from '../../Modals/FillSupplierModal';
// import FillInventoryModal from '../../Modals/FillInventoryModal';
// import FillAdditionalAttributeModal from '../../Modals/AdditionalAttributesModal';
// import { useNavigate, useParams } from 'react-router-dom';
// import APIService from '../../../Services/APIService';
// import additional_attributes_dict from '../CommonAttr';
// import TableHeader from '../../Shared/TableHeader';
// import { BackButton } from '../../Shared/BackButton';
// import { Form, Button, Modal, Row, Col } from 'react-bootstrap';
// import DataNotFound from '../../Shared/DataNotFound';
// import DateRangeFilter from '../../Shared/DateRangeFilter/DateRangeFilter.tsx';

// const CreateSupplier = () => {
//   const getOption = (options, value, { optionValueKey }) => {
//     if (!options || !options.length) return {};
//     for (let i = 0, l = options.length; i < l; i += 1) {
//       if (options[i][optionValueKey] === value) {
//         return options[i];
//       }
//     }
//     return {};
//   };

//   const navigation = useNavigate();
//   const params = useParams();
//   const isEditMode = !!params.supplierId;
//   const supplierId = params.supplierId;
//   const [name, setName] = useState('');
//   const [supplierAttributes, setSupplierAttributes] = useState([]);
//   const [supplierList, setSupplierList] = useState([]);
//   const [baseInventory, setBaseInventory] = useState([]);
//   const [inventoryList, setInventoryList] = useState([]);
//   const [selectedInventoryList, setSelectdInventoryList] = useState([]);
//   const [currentSupplierId, setCurrentSupplierId] = useState('');
//   const [additionalAttributes, setAdditionalAttributes] = useState({});
//   const [selectedSupplierType, setSelectedSupplierType] = useState(null);
//   const [showOptionModal, setShowOptionModal] = useState(false);
//   const [attributeValueOptions, setAttributeValueOptions] = useState(['']);
//   const [attributeValueInfo, setattributeValueInfo] = useState({});
//   const [showFillSupplierModal, setShowFillSupplierModal] = useState(false);
//   const [currentModalSupplierType, setCurrentModalSupplierType] = useState(undefined);
//   const [isFillInventoryModalVisible, setIsFillInventoryModalVisible] = useState(false);
//   const [isAdditionalAttributeModalVisible, setIsAdditionalAttributeModalVisible] = useState(false);
//   const [selectedInventory, setSelectedInventory] = useState(null);
//   const [selectedAdditionalAttribute, setSelectedAdditionalAttribute] = useState(null);
//   const [selectedFieldName, setSelectedFieldName] = useState(undefined);
//   // const [supplierTypeOption, setSupplierTypeOption] = useState([]);
//   const [additionalAttributesList] = useState([
//     { label: 'Bank Details', value: 'bank_details' },
//     { label: 'Contact Details', value: 'contact_details' },
//     { label: 'Location Details', value: 'location_details' },
//     { label: 'Society Details', value: 'society_details' },
//   ]);

//   const getSupplierTypeList = async () => {
//     let res = await APIService.get(`/v0/ui/dynamic-suppliers/supplier-type/`);
//     if (res.status == 200) {
//       let supplierLists = Object.values(res?.data?.list);
//       // let supplierTypeOption = [];
//       // supplierLists &&
//       //   supplierLists.forEach((supplierType) => {
//       //     supplierTypeOption.push({
//       //       value: supplierType.id,
//       //       label: supplierType.name,
//       //     });
//       //   });
//       // setSupplierTypeOption(supplierTypeOption);
//       setSupplierList(supplierLists);
//     }
//   };

//   const getInventoryList = async () => {
//     let res = await APIService.get(`/v0/ui/dynamic-inventory/inventory/`);
//     console.log(res?.data);
//     if (res.status == 200) setInventoryList(Object.values(res?.data?.list));
//   };

//   const getSupplierById = async (supplierId) => {
//     let res = await APIService.get(`/v0/ui/dynamic-suppliers/supplier/${supplierId}/`);
//     if (res.status == 200) {
//       let currentSupplier = res.data;
//       setSelectedSupplierType(
//         getOption(supplierList, currentSupplier.supplier_type_id, { optionValueKey: 'value' })
//       );
//       setCurrentSupplierId(currentSupplier?.supplier_type_id);
//       setName(currentSupplier.name);
//       setSupplierAttributes(currentSupplier?.supplier_attributes);
//       setSelectdInventoryList(currentSupplier.inventory_list);
//       setAdditionalAttributes(currentSupplier.additional_attributes);
//     }
//   };

//   const getBaseInventory = async () => {
//     let res = await APIService.get(`/v0/ui/dynamic-inventory/base-inventory/`);
//     if (res.status == 200) {
//       setBaseInventory(res?.data?.list);
//     }
//   };

//   const onCancelFillSupplierModal = () => {
//     setShowFillSupplierModal(false);
//     setCurrentModalSupplierType(undefined);
//   };

//   const onSubmitFillSupplierModal = (currentModalSupplierType, attributeInfo) => {
//     setattributeValueInfo({});
//     setShowFillSupplierModal(false);
//     setCurrentModalSupplierType(undefined);
//     let newAttributes = Object.assign({}, attributeInfo.attribute, {
//       value: currentModalSupplierType,
//     });
//     handleAttributeChange(newAttributes, attributeInfo.attrIndex);
//   };

//   const onOpenFillSupplierModal = (currentModalSupplierType, attribute, attrIndex) => {
//     setattributeValueInfo({
//       attribute,
//       attrIndex,
//     });
//     setShowFillSupplierModal(true);
//     setCurrentModalSupplierType(currentModalSupplierType);
//   };

//   const onFillInventoryModalClick = (inventory) => {
//     setIsFillInventoryModalVisible(true);
//     setSelectedInventory(inventory);
//   };

//   const onFillAdditionalAttributeModalClick = (attributes, attribute) => {
//     setSelectedAdditionalAttribute(attributes[attribute]);
//     setSelectedFieldName(attribute);
//     setIsAdditionalAttributeModalVisible(true);
//   };

//   const onFillInventoryModalClose = () => {
//     setIsFillInventoryModalVisible(false);
//     setSelectedInventory({});
//   };

//   const onFillAdditionalAttributeModalClose = () => {
//     setSelectedAdditionalAttribute({});
//     setIsAdditionalAttributeModalVisible(false);
//   };

//   const onInventoryChange = (selectedInventory) => {
//     if (selectedInventory) setSelectedInventory(selectedInventory);
//     else setSelectedInventory(null);
//   };

//   const onAddInventory = () => {
//     if (Object?.keys(selectedInventory).length == 0) return;
//     inventoryList.push(selectedInventory);
//     setSelectdInventoryList([...selectedInventoryList, selectedInventory]);
//     setSelectedInventory(null);
//   };

//   const onAdditionalAttributeChange = (e) => {
//     if (e) setSelectedAdditionalAttribute(e);
//     else setSelectedAdditionalAttribute(null);
//   };

//   const onAddAdditionalAttributes = () => {
//     if (selectedAdditionalAttribute.value == undefined) {
//       return;
//     }
//     additionalAttributes[selectedAdditionalAttribute.value] =
//       additional_attributes_dict[selectedAdditionalAttribute.value];
//     setAdditionalAttributes(additionalAttributes);
//     setSelectedAdditionalAttribute(null);
//   };

//   const onCancelOptionModal = () => {
//     setShowOptionModal(false);
//     setAttributeValueOptions(['']);
//     setattributeValueInfo({});
//   };

//   const onSubmitOptionModal = (options, attributeInfo) => {
//     setShowOptionModal(false);
//     setAttributeValueOptions(['']);
//     setattributeValueInfo({});

//     let newAttributes = Object.assign({}, attributeInfo.attribute, {
//       value: options,
//     });
//     handleAttributeChange(newAttributes, attributeInfo.attrIndex);
//   };

//   const onSelectSupplierType = (selectedSupplierType) => {
//     if (supplierList && selectedSupplierType?.id) {
//       supplierList.forEach((supplierType) => {
//         if (supplierType.id === selectedSupplierType?.id) {
//           setSupplierAttributes(supplierType.supplier_attributes);
//           setSelectdInventoryList(supplierType.inventory_list);
//           setAdditionalAttributes(supplierType.additional_attributes);
//           setSelectedSupplierType(selectedSupplierType);
//           return;
//         }
//       });
//     } else {
//       setSelectedSupplierType({});
//     }
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     let data = {
//       name: name,
//       is_custom: false,
//       supplier_type_id: selectedSupplierType?.id || currentSupplierId,
//       supplier_attributes: supplierAttributes,
//       inventory_list: inventoryList,
//       additional_attributes: additionalAttributes,
//     };

//     if (isEditMode) {
//       let res = await APIService.put(`/v0/ui/dynamic-suppliers/supplier/${supplierId}/`, data);
//       if (res == 200) {
//         SweetAlert('Supplier updated successfully', 'success');
//         navigation('/r/supplier/list');
//       }
//     } else {
//       let res = await APIService.post(`/v0/ui/dynamic-suppliers/supplier/`, data);
//       if (res.status == 200) {
//         SweetAlert('Supplier created successfully', 'success');
//         navigation('/r/supplier/list');
//       }
//     }
//   };

//   const handleAttributeChange = (attribute, index) => {
//     const attributes = supplierAttributes.slice();
//     attributes.splice(index, 1, attribute);
//     setSupplierAttributes(attributes);
//   };

//   // const handleDateChange = (date, index) => {
//   //   let data = supplierAttributes;
//   //   data[index].value = date.format('YYYY-MM-DD');
//   //   setSupplierAttributes(data);
//   // };

//   const renderInputField = (attribute, attrIndex) => {
//     const onValueChange = (event) => {
//       console.log(event);
//       const newAttribute = Object.assign({}, attribute);

//       if (event.target.type === 'number') {
//         newAttribute.value = parseFloat(event.target.value);
//       } else {
//         newAttribute.value = event.target.value;
//       }
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     const onDropDownAttributeValueChange = (newValue) => {
//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.value = newValue?.value;
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     const onDateChange = (date) => {
//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.value = date;
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     switch (attribute.type) {
//       case 'FLOAT':
//         return (
//           <Form.Control
//             type="number"
//             placeholder="Attribute Value"
//             value={attribute.value}
//             onChange={onValueChange}
//           />
//         );
//       case 'INT':
//         return (
//           <Form.Control
//             type="number"
//             placeholder="Attribute Value"
//             value={attribute.value}
//             onChange={onValueChange}
//           />
//         );
//       case 'STRING':
//         return (
//           <Form.Control
//             type="text"
//             placeholder="Attribute Value"
//             value={attribute.value}
//             onChange={onValueChange}
//           />
//         );
//       case 'EMAIL':
//         return (
//           <Form.Control
//             type="email"
//             placeholder="Attribute Value"
//             value={attribute.value}
//             onChange={onValueChange}
//           />
//         );
//       case 'DROPDOWN':
//         let attributeValueOptions = [];
//         attribute.options.forEach((option) => {
//           attributeValueOptions.push({ label: option, value: option });
//         });
//         return (
//           <SelectDropdown
//             optionsData={attributeValueOptions}
//             selectedValue={{ label: attribute.value, value: attribute.value }}
//             handleSelect={onDropDownAttributeValueChange}
//             id={`${attrIndex}-dropdown`}
//           />
//         );
//       case 'INVENTORY_TYPE':
//         return (
//           <Button
//             type="button"
//             variant="primary"
//             onClick={() => onOpenFillSupplierModal(attribute.value, attribute, attrIndex)}
//           >
//             {attribute.value && attribute.value.attributes[0].value
//               ? 'Show Base Inventory List'
//               : 'Create Base Inventory List'}
//           </Button>
//         );

//       case 'INVENTORY':
//         return (
//           <Button
//             type="button"
//             variant="primary"
//             onClick={() => onOpenFillSupplierModal(attribute.value, attribute, attrIndex)}
//           >
//             {attribute.value && attribute.value.attributes[0].value
//               ? 'Show Inventory List'
//               : 'Create Inventory List'}
//           </Button>
//         );

//       case 'SUPPLIER_TYPE':
//         return (
//           <Button
//             type="button"
//             variant="primary"
//             onClick={() => onOpenFillSupplierModal(attribute.value, attribute, attrIndex)}
//           >
//             {attribute.value && attribute.value.attributes[0].value
//               ? 'Show Supplier Type Data'
//               : 'Create Supplier Type Data'}
//           </Button>
//         );
//       case 'BASE_SUPPLIER_TYPE':
//         return (
//           <Button
//             type="button"
//             variant="primary"
//             onClick={() => onOpenFillSupplierModal(attribute.value, attribute, attrIndex)}
//           >
//             {attribute.value && attribute.value.attributes[0].value
//               ? 'Show Base Supplier Type Data'
//               : 'Create Base Supplier Type Data'}
//           </Button>
//         );
//       case 'DATETIME':
//         console.log(attribute, '222');
//         return (
//           <DateRangeFilter
//             selectDate={attribute?.value ? new Date(attribute?.value) : null}
//             showPlaceholder={attribute?.value}
//             onDateChange={(e) => {
//               onDateChange(e, attrIndex); // handleDateChange(e, attrIndex);
//             }}
//           />
//         );
//       default:
//         return;
//     }
//   };

//   const renderAdditionalAttributeRow = (attribute) => {
//     return (
//       <Row className="mt-2" key={additionalAttributes[attribute]}>
//         <Col>
//           <Form.Group>
//             <Form.Label>
//               {attribute.replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function (attribute) {
//                 return attribute.toUpperCase();
//               })}{' '}
//               :
//             </Form.Label>
//           </Form.Group>
//         </Col>
//         <Col>
//           <Button
//             type="button"
//             variant="primary"
//             onClick={() => onFillAdditionalAttributeModalClick(additionalAttributes, attribute)}
//           >
//             View / Edit Additional Attributes
//           </Button>
//         </Col>
//       </Row>
//     );
//   };

//   const additionalAttributesNames = additionalAttributes && Object.keys(additionalAttributes);
//   const additionalAttributesLists =
//     additionalAttributesList &&
//     additionalAttributesList.filter(
//       (item) => additionalAttributesNames?.indexOf(item.value) === -1
//     );

//   useEffect(() => {
//     const newArray = baseInventory?.filter(
//       (item1) => !selectedInventoryList?.some((item2) => item2?._id === item1?._id)
//     );
//     setBaseInventory(newArray);
//   }, [selectedInventoryList]);

//   useEffect(() => {
//     getSupplierTypeList();
//     getInventoryList();
//     getBaseInventory();

//     if (isEditMode) {
//       getSupplierById(supplierId);
//     }
//   }, []);

//   const backButton = () => {
//     return <BackButton onClick={() => navigation(`/r/supplier/list`)} />;
//   };

//   return (
//     <>
//       <TableHeader
//         headerValue={`Supplier - ${isEditMode ? 'Edit' : 'Create'}`}
//         isBackButton={backButton}
//       />
//       <Form onSubmit={onSubmit}>
//         <Row>
//           <Col xs={12}>
//             <Form.Group>
//               <Form.Label>
//                 Enter Name For Supplier <span className="required-field">*</span>
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="name"
//                 value={name}
//                 placeholder="Supplier Name"
//                 onChange={(e) => setName(e.target.value)}
//               />
//             </Form.Group>
//           </Col>
//         </Row>
//         {!isEditMode && (
//           <Row>
//             <Col xs={12}>
//               <Form.Group>
//                 <Form.Label>
//                   Select Supplier Type <span className="required-field">*</span>
//                 </Form.Label>
//                 <SelectDropdown
//                   // optionsData={supplierTypeOption}
//                   optionsData={supplierList}
//                   selectedValue={selectedSupplierType}
//                   OptionLabel="name"
//                   OptionValue="id"
//                   placeholder="Select Supplier Type"
//                   label="Supplier Type"
//                   id="supplierType"
//                   handleSelect={onSelectSupplierType}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>
//         )}
//         <Form.Label className="mt-3">Attributes</Form.Label>
//         {supplierAttributes && supplierAttributes.length ? (
//           // supplierAttributes.map(renderAttributeRow)
//           supplierAttributes.map((attribute, index) => {
//             return (
//               <Row key={`row-${index}`} className="mt-2">
//                 <Col>
//                   <Form.Group>
//                     <Form.Label>{attribute?.name} :</Form.Label>
//                   </Form.Group>
//                 </Col>
//                 <Col> {renderInputField(attribute, index)}</Col>
//               </Row>
//             );
//           })
//         ) : (
//           <DataNotFound message="No attributes available" />
//         )}
//         <Form.Label className="mt-3">Inventories</Form.Label>
//         {selectedInventoryList && selectedInventoryList.length ? (
//           selectedInventoryList?.map((inventoryRow, index) => {
//             return (
//               <Row key={inventoryRow._id} className="mt-2">
//                 <Col>
//                   <Form.Group>
//                     <Form.Label>{inventoryRow?.name} :</Form.Label>
//                   </Form.Group>
//                 </Col>
//                 <Col>
//                   <Button variant="primary" onClick={() => onFillInventoryModalClick(inventoryRow)}>
//                     View / Edit Inventory Attributes
//                   </Button>
//                 </Col>
//               </Row>
//             );
//           })
//         ) : (
//           <DataNotFound message="No inventory available" />
//         )}
//         <Form.Label className="mt-3">Add More Inventories</Form.Label>
//         <Row>
//           <Col xs={12} md={6}>
//             <Form.Group>
//               <SelectDropdown
//                 id="base-inventory"
//                 placeholder={'Add More Inventories'}
//                 optionsData={baseInventory}
//                 OptionLabel={'name'}
//                 OptionValue={'_id'}
//                 selectedValue={selectedInventory}
//                 handleSelect={onInventoryChange}
//               />
//             </Form.Group>
//           </Col>
//           <Col xs={12} md={6}>
//             <Button
//               variant="primary"
//               type="button"
//               onClick={() => {
//                 onAddInventory();
//               }}
//               disabled={!selectedInventory}
//             >
//               Add Inventory
//             </Button>
//           </Col>
//         </Row>
//         <Form.Label className="mt-3">Additional Attributes</Form.Label>
//         {Object.keys(additionalAttributes).length ? (
//           Object.keys(additionalAttributes).map(renderAdditionalAttributeRow)
//         ) : (
//           <DataNotFound message="No Additional Attributes available" />
//         )}
//         <Form.Label className="mt-3">Add More Additional Attributes</Form.Label>
//         <Row>
//           <Col xs={12} md={6}>
//             <Form.Group>
//               <SelectDropdown
//                 id="additional-attributes"
//                 placeholder={'Add More Additional Attributes'}
//                 optionsData={additionalAttributesLists}
//                 selectedValue={selectedAdditionalAttribute}
//                 handleSelect={onAdditionalAttributeChange}
//               />
//             </Form.Group>
//           </Col>
//           <Col xs={12} md={6}>
//             <Button
//               variant="primary"
//               type="button"
//               onClick={() => {
//                 onAddAdditionalAttributes();
//               }}
//             >
//               Add Additional Attributes
//             </Button>
//           </Col>
//         </Row>
//         <div className="mt-2">
//           <Button type="submit" variant="primary">
//             Submit
//           </Button>
//         </div>
//       </Form>
//       {showOptionModal && (
//         <OptionModal
//           key={attributeValueInfo?.attrIndex}
//           showOptionModal={showOptionModal}
//           onCancel={onCancelOptionModal}
//           onSubmit={onSubmitOptionModal}
//           options={attributeValueOptions}
//           columnInfo={attributeValueInfo}
//         />
//       )}
//       {showFillSupplierModal && (
//         <FillSupplierModal
//           showOptionModal={showFillSupplierModal}
//           onCancel={onCancelFillSupplierModal}
//           onSubmit={onSubmitFillSupplierModal}
//           columnInfo={attributeValueInfo}
//           selectedSupplierType={currentModalSupplierType}
//         />
//       )}
//       {isFillInventoryModalVisible && (
//         <FillInventoryModal
//           key={selectedInventory?._id}
//           isVisible={isFillInventoryModalVisible}
//           inventory={selectedInventory}
//           onChange={onInventoryChange}
//           onClose={onFillInventoryModalClose}
//         />
//       )}
//       {isAdditionalAttributeModalVisible && (
//         <FillAdditionalAttributeModal
//           key={selectedAdditionalAttribute}
//           isVisible={isAdditionalAttributeModalVisible}
//           attributes={selectedAdditionalAttribute}
//           onChange={onAdditionalAttributeChange}
//           onClose={onFillAdditionalAttributeModalClose}
//           attribute={selectedFieldName}
//         />
//       )}
//     </>
//   );
// };
// export default CreateSupplier;




import React, { useEffect, useState } from 'react';
import OptionModal from '../../Modals/OptionModal';
import FillSupplierModal from '../../Modals/FillSupplierModal';
import FillInventoryModal from '../../Modals/FillInventoryModal';
import FillAdditionalAttributeModal from '../../Modals/AdditionalAttributesModal';
import { useNavigate, useParams } from 'react-router-dom';
import APIService from '../../../Services/APIService';
import additional_attributes_dict from '../CommonAttr';
import { BackButton } from '../../Shared/BackButton';
import DataNotFound from '../../Shared/DataNotFound';
import DateRangeFilter from '../../Shared/DateRangeFilter/DateRangeFilter.tsx';
import { Box, Button, FormControl, Grid, TextField, Typography } from '@mui/material';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx'
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { mt } from 'date-fns/locale';


const CreateSupplier = () => {
  const getOption = (options, value, { optionValueKey }) => {
    if (!options || !options.length) return {};
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i][optionValueKey] === value) {
        return options[i];
      }
    }
    return {};
  };

  const navigation = useNavigate();
  const params = useParams();
  const isEditMode = !!params.supplierId;
  const supplierId = params.supplierId;
  const [name, setName] = useState('');
  const { showSnackBar } = useSnackBar();
  const [supplierAttributes, setSupplierAttributes] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [baseInventory, setBaseInventory] = useState([]);
  const [inventoryList, setInventoryList] = useState([]);
  const [selectedInventoryList, setSelectdInventoryList] = useState([]);
  const [currentSupplierId, setCurrentSupplierId] = useState('');
  const [additionalAttributes, setAdditionalAttributes] = useState({});
  const [selectedSupplierType, setSelectedSupplierType] = useState(null);
  const [showOptionModal, setShowOptionModal] = useState(false);
  const [attributeValueOptions, setAttributeValueOptions] = useState(['']);
  const [attributeValueInfo, setattributeValueInfo] = useState({});
  const [showFillSupplierModal, setShowFillSupplierModal] = useState(false);
  const [currentModalSupplierType, setCurrentModalSupplierType] = useState(undefined);
  const [isFillInventoryModalVisible, setIsFillInventoryModalVisible] = useState(false);
  const [isAdditionalAttributeModalVisible, setIsAdditionalAttributeModalVisible] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [selectedAdditionalAttribute, setSelectedAdditionalAttribute] = useState(null);
  const [selectedFieldName, setSelectedFieldName] = useState(undefined);
  // const [supplierTypeOption, setSupplierTypeOption] = useState([]);
  const [additionalAttributesList] = useState([
    { label: 'Bank Details', value: 'bank_details' },
    { label: 'Contact Details', value: 'contact_details' },
    { label: 'Location Details', value: 'location_details' },
    { label: 'Society Details', value: 'society_details' },
  ]);

  const getSupplierTypeList = async () => {
    let res = await APIService.get(`/v0/ui/dynamic-suppliers/supplier-type/`);
    if (res.status == 200) {
      let supplierLists = Object.values(res?.data?.list);
      // let supplierTypeOption = [];
      // supplierLists &&
      //   supplierLists.forEach((supplierType) => {
      //     supplierTypeOption.push({
      //       value: supplierType.id,
      //       label: supplierType.name,
      //     });
      //   });
      // setSupplierTypeOption(supplierTypeOption);
      setSupplierList(supplierLists);
    }
  };

  const getInventoryList = async () => {
    let res = await APIService.get(`/v0/ui/dynamic-inventory/inventory/`);
    console.log(res?.data);
    if (res.status == 200) setInventoryList(Object.values(res?.data?.list));
  };

  const getSupplierById = async (supplierId) => {
    let res = await APIService.get(`/v0/ui/dynamic-suppliers/supplier/${supplierId}/`);
    if (res.status == 200) {
      let currentSupplier = res.data;
      setSelectedSupplierType(
        getOption(supplierList, currentSupplier.supplier_type_id, { optionValueKey: 'value' })
      );
      setCurrentSupplierId(currentSupplier?.supplier_type_id);
      setName(currentSupplier.name);
      setSupplierAttributes(currentSupplier?.supplier_attributes);
      setSelectdInventoryList(currentSupplier.inventory_list);
      setAdditionalAttributes(currentSupplier.additional_attributes);
    }
  };

  const getBaseInventory = async () => {
    let res = await APIService.get(`/v0/ui/dynamic-inventory/base-inventory/`);
    if (res.status == 200) {
      setBaseInventory(res?.data?.list);
    }
  };

  const onCancelFillSupplierModal = () => {
    setShowFillSupplierModal(false);
    setCurrentModalSupplierType(undefined);
  };

  const onSubmitFillSupplierModal = (currentModalSupplierType, attributeInfo) => {
    setattributeValueInfo({});
    setShowFillSupplierModal(false);
    setCurrentModalSupplierType(undefined);
    let newAttributes = Object.assign({}, attributeInfo.attribute, {
      value: currentModalSupplierType,
    });
    handleAttributeChange(newAttributes, attributeInfo.attrIndex);
  };

  const onOpenFillSupplierModal = (currentModalSupplierType, attribute, attrIndex) => {
    setattributeValueInfo({
      attribute,
      attrIndex,
    });
    setShowFillSupplierModal(true);
    setCurrentModalSupplierType(currentModalSupplierType);
  };

  const onFillInventoryModalClick = (inventory) => {
    setIsFillInventoryModalVisible(true);
    setSelectedInventory(inventory);
  };

  const onFillAdditionalAttributeModalClick = (attributes, attribute) => {
    setSelectedAdditionalAttribute(attributes[attribute]);
    setSelectedFieldName(attribute);
    setIsAdditionalAttributeModalVisible(true);
  };

  const onFillInventoryModalClose = () => {
    setIsFillInventoryModalVisible(false);
    setSelectedInventory({});
  };

  const onFillAdditionalAttributeModalClose = () => {
    setSelectedAdditionalAttribute({});
    setIsAdditionalAttributeModalVisible(false);
  };

  const onInventoryChange = (selectedInventory) => {
    if (selectedInventory) setSelectedInventory(selectedInventory);
    else setSelectedInventory(null);
  };

  const onAddInventory = () => {
    if (Object?.keys(selectedInventory).length == 0) return;
    inventoryList.push(selectedInventory);
    setSelectdInventoryList([...selectedInventoryList, selectedInventory]);
    setSelectedInventory(null);
  };

  const onAdditionalAttributeChange = (e) => {
    if (e) setSelectedAdditionalAttribute(e);
    else setSelectedAdditionalAttribute(null);
  };

  // const onAddAdditionalAttributes = () => {
  //   if (selectedAdditionalAttribute.value == undefined) {
  //     return;
  //   }
  //   additionalAttributes[selectedAdditionalAttribute.value] =
  //     additional_attributes_dict[selectedAdditionalAttribute.value];
  //   setAdditionalAttributes(additionalAttributes);
  //   setSelectedAdditionalAttribute(null);
  // };

  const onAddAdditionalAttributes = () => {
    if (!selectedAdditionalAttribute || selectedAdditionalAttribute.value === undefined) {
      return;
    }
    additionalAttributes[selectedAdditionalAttribute.value] =
      additional_attributes_dict[selectedAdditionalAttribute.value];
    setAdditionalAttributes({ ...additionalAttributes });
    setSelectedAdditionalAttribute(null);
  };

  const onCancelOptionModal = () => {
    setShowOptionModal(false);
    setAttributeValueOptions(['']);
    setattributeValueInfo({});
  };

  const onSubmitOptionModal = (options, attributeInfo) => {
    setShowOptionModal(false);
    setAttributeValueOptions(['']);
    setattributeValueInfo({});

    let newAttributes = Object.assign({}, attributeInfo.attribute, {
      value: options,
    });
    handleAttributeChange(newAttributes, attributeInfo.attrIndex);
  };

  const onSelectSupplierType = (selectedSupplierType) => {
    if (supplierList && selectedSupplierType?.id) {
      supplierList.forEach((supplierType) => {
        if (supplierType.id === selectedSupplierType?.id) {
          setSupplierAttributes(supplierType.supplier_attributes);
          setSelectdInventoryList(supplierType.inventory_list);
          setAdditionalAttributes(supplierType.additional_attributes);
          setSelectedSupplierType(selectedSupplierType);
          return;
        }
      });
    } else {
      setSelectedSupplierType({});
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    let data = {
      name: name,
      is_custom: false,
      supplier_type_id: selectedSupplierType?.id || currentSupplierId,
      supplier_attributes: supplierAttributes,
      inventory_list: inventoryList,
      additional_attributes: additionalAttributes,
    };

    if (isEditMode) {
      let res = await APIService.put(`/v0/ui/dynamic-suppliers/supplier/${supplierId}/`, data);
      if (res == 200) {
        showSnackBar('Supplier updated successfully', 'success');
        navigation('/r/supplier/list');
      }
    } else {
      let res = await APIService.post(`/v0/ui/dynamic-suppliers/supplier/`, data);
      if (res.status == 200) {
        showSnackBar('Supplier created successfully', 'success');
        navigation('/r/supplier/list');
      }
    }
  };

  const handleAttributeChange = (attribute, index) => {
    const attributes = supplierAttributes.slice();
    attributes.splice(index, 1, attribute);
    setSupplierAttributes(attributes);
  };

  // const handleDateChange = (date, index) => {
  //   let data = supplierAttributes;
  //   data[index].value = date.format('YYYY-MM-DD');
  //   setSupplierAttributes(data);
  // };

  const renderInputField = (attribute, attrIndex) => {
    const onValueChange = (event) => {
      console.log(event);
      const newAttribute = Object.assign({}, attribute);

      if (event.target.type === 'number') {
        newAttribute.value = parseFloat(event.target.value);
      } else {
        newAttribute.value = event.target.value;
      }
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onDropDownAttributeValueChange = (newValue) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.value = newValue?.value;
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onDateChange = (date) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.value = date;
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onDateRangeApply = (date) => {
      console.log('Date Range Applied:', date);
    };

    switch (attribute.type) {
      case 'FLOAT':
      case 'INT':
        return (
          <TextField
            type="number"
            label="Attribute Value"
            slotProps={{
              inputLabel: {
                sx: { top: '-7px' }
              }
            }}
            value={attribute.value}
            onChange={onValueChange}
            fullWidth
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
               sx: {
                  '& input': {
                    padding: '8px', 
                  },
                },
            }}
          />
        );
      case 'STRING':
        return (
          <TextField
            type="text"
            label="Attribute Value"
            slotProps={{
              inputLabel: {
                sx: { top: '-7px' }
              }
            }}
            value={attribute.value}
            onChange={onValueChange}
            fullWidth
             InputProps={{
                sx: {
                  '& input': {
                    padding: '8px', 
                  },
                },
              }}
          />
        );
      case 'EMAIL':
        return (
          <TextField
            type="email"
            label="Attribute Value"
            slotProps={{
              inputLabel: {
                sx: { top: '-7px' }
              }
            }}
            value={attribute.value}
            onChange={onValueChange}
            fullWidth
             InputProps={{
                sx: {
                  '& input': {
                    padding: '8px', 
                  },
                },
              }}
          />
        );
      case 'DROPDOWN':
        const attributeValueOptions = attribute.options.map((option) => ({
          label: option,
          value: option,
        }));
        return (
          <FormControl fullWidth>
            <InputLabel id={`dropdown-${attrIndex}`}>Select an Option</InputLabel>
            <Select
              labelId={`dropdown-${attrIndex}`}
              value={attribute.value}
              onChange={(e) => onDropDownAttributeValueChange(e.target.value)}
              label="Select an Option"
            >
              {attributeValueOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      case 'INVENTORY_TYPE':
      case 'INVENTORY':
      case 'SUPPLIER_TYPE':
      case 'BASE_SUPPLIER_TYPE':
        return (
          <Button
            type="button"
            variant="contained"
            color="primary"
            onClick={() => onOpenFillSupplierModal(attribute.value, attribute, attrIndex)}
          >
            {attribute.value && attribute.value.attributes[0].value
              ? `Show ${attribute.type.replace('_', ' ')} List`
              : `Create ${attribute.type.replace('_', ' ')} List`}
          </Button>
        );
      case 'DATETIME':
        return (
          <DateRangeFilter
            selectDate={attribute?.value ? new Date(attribute?.value) : null}
            showPlaceholder={attribute?.value}
            onDateChange={(e) => {
              onDateChange(e, attrIndex); // handleDateChange(e, attrIndex);
            }}
            onApply={onDateRangeApply}
          />
        );
      default:
        return null;
    }
  };

  const renderAdditionalAttributeRow = (attribute) => {
    return (
      <Grid container spacing={2} sx={{mx: {xs: 0, sm: 0}}} mt={0} key={attribute}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">
            {attribute
              .replace(/_/g, ' ') // Replace underscores with spaces
              .replace(/(?: |\b)(\w)/g, (match) => match.toUpperCase())} :
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            variant="contained"
            color='primary'
            onClick={() => onFillAdditionalAttributeModalClick(additionalAttributes, attribute)}
          >
            View / Edit Additional Attributes
          </Button>
        </Grid>
      </Grid>
    );
  };

  const additionalAttributesNames = additionalAttributes && Object.keys(additionalAttributes);
  const additionalAttributesLists =
    additionalAttributesList &&
    additionalAttributesList.filter(
      (item) => additionalAttributesNames?.indexOf(item.value) === -1
    );

  useEffect(() => {
    const newArray = baseInventory?.filter(
      (item1) => !selectedInventoryList?.some((item2) => item2?._id === item1?._id)
    );
    setBaseInventory(newArray);
  }, [selectedInventoryList]);

  useEffect(() => {
    getSupplierTypeList();
    getInventoryList();
    getBaseInventory();

    if (isEditMode) {
      getSupplierById(supplierId);
    }
  }, []);

  const backButton = () => {
    return <BackButton onClick={() => navigation(`/r/supplier/list`)} />;
  };

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px',p:1 }}>
      {/* <TableHeader
        headerValue={`Supplier - ${isEditMode ? 'Edit' : 'Create'}`}
        isBackButton={backButton}
      /> */}
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" fontWeight="bold" sx={{mb:1}}>
            {`Supplier - ${isEditMode ? 'Edit' : 'Create'}`}
          </Typography>
        </Grid>
        <Grid item>
          <BackButton onClick={() => navigation(`/r/supplier/list`)} />
        </Grid>
      </Grid>
      <Box component="form" onSubmit={onSubmit} noValidate autoComplete="off">
        <Grid container spacing={2} sx={{mt:0}}>
          <Grid item xs={12} sm={6}>
            <Typography mb={1}>
              Enter Name For Supplier <span className="required-field">*</span>
            </Typography>
            <TextField
              fullWidth
              type="text"
              name="name"
              value={name}
              placeholder="Supplier Name"
               InputProps={{
                  sx: {
                    '& input': {
                      padding: '8px',
                    },
                    
                  },
                }}
              onChange={(e) => setName(e.target.value)}
              variant="outlined"
              required
            />
          </Grid>
          {!isEditMode && (
            <Grid item xs={12} sm={6}>
              <Typography mb={1}>
                Select Supplier Type <span className="required-field">*</span>
              </Typography>
              <FormControl fullWidth>
                <SearchableDropdown
                  options={supplierList}
                  labelKey="name"
                  valueKey="id"
                  label="Supplier Type"
                  value={selectedSupplierType}
                  onChange={onSelectSupplierType}
                  placeholder="Select Supplier Type"
                  error={false}
                />
              </FormControl>
            </Grid>
          )}
          
          {/* Attributes */}
          <Grid item xs={12} mt={1}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Attributes
            </Typography>
          </Grid>
          {supplierAttributes && supplierAttributes.length ? (
            supplierAttributes.map((attribute, index) => (
              <Grid container spacing={2} key={`attr-${index}`} sx={{mx: {xs: 0}, mb: {xs: 1, sm: 2}}}>
                <Grid item xs={12} sm={6}>
                  <Typography>{attribute?.name} :</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {renderInputField(attribute, index)}
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <DataNotFound message="No attributes available" />
            </Grid>
          )}

          {/* Inventories */}
          <Grid item xs={12} mt={0}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Inventories
            </Typography>
          </Grid>
          {selectedInventoryList && selectedInventoryList.length ? (
            selectedInventoryList.map((inventoryRow) => (
              <Grid container spacing={2} key={inventoryRow._id} sx={{mx: {xs: 0}, mb: {xs: 1, sm: 2}}}>
                <Grid item xs={12} sm={6}>
                  <Typography>{inventoryRow?.name} :</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    onClick={() => onFillInventoryModalClick(inventoryRow)}
                  >
                    View / Edit Inventory Attributes
                  </Button>
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <DataNotFound message="No inventory available" />
            </Grid>
          )}

          {/* Add More Inventories */}
          <Grid item xs={12} mt={0}>
            <Typography variant="h6">
              Add More Inventories
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <SearchableDropdown
                options={baseInventory}
                labelKey="name"
                valueKey="_id"
                value={selectedInventory}
                onChange={onInventoryChange}
                label="Add More Inventories"
                loading={false}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              variant="contained"
              onClick={onAddInventory}
              disabled={!selectedInventory}
            >
              Add Inventory
            </Button>
          </Grid>

          {/* Additional Attributes */}
          <Grid item xs={12} mt={1}>
            <Typography variant="h6">
              Additional Attributes
            </Typography>
          </Grid>
          {Object.keys(additionalAttributes).length ? (
            Object.keys(additionalAttributes).map(renderAdditionalAttributeRow)
          ) : (
            <Grid item xs={12}>
              <DataNotFound message="No Additional Attributes available" />
            </Grid>
          )}

          {/* Add More Additional Attributes */}
          <Grid item xs={12} mt={1}>
            <Typography variant="h6" >
              Add More Additional Attributes
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ml :{sx:0, sm:0}}}>
            <FormControl fullWidth>
              <SearchableDropdown
                options={additionalAttributesLists}
                labelKey="label"
                valueKey="value"
                value={selectedAdditionalAttribute}
                onChange={onAdditionalAttributeChange}
                label="Add More Additional Attributes"
                onSearch={(searchText) => {
                  console.log('Searching for:', searchText);
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button variant="contained" onClick={onAddAdditionalAttributes}>
              Add Additional Attributes
            </Button>
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Button type="submit" variant="contained">
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
      {showOptionModal && (
        <OptionModal
          key={attributeValueInfo?.attrIndex}
          showOptionModal={showOptionModal}
          onCancel={onCancelOptionModal}
          onSubmit={onSubmitOptionModal}
          options={attributeValueOptions}
          columnInfo={attributeValueInfo}
        />
      )}
      {showFillSupplierModal && (
        <FillSupplierModal
          showOptionModal={showFillSupplierModal}
          onCancel={onCancelFillSupplierModal}
          onSubmit={onSubmitFillSupplierModal}
          columnInfo={attributeValueInfo}
          selectedSupplierType={currentModalSupplierType}
        />
      )}
      {isFillInventoryModalVisible && (
        <FillInventoryModal
          key={selectedInventory?._id}
          isVisible={isFillInventoryModalVisible}
          inventory={selectedInventory}
          onChange={onInventoryChange}
          onClose={onFillInventoryModalClose}
        />
      )}
      {isAdditionalAttributeModalVisible && (
        <FillAdditionalAttributeModal
          key={selectedAdditionalAttribute}
          isVisible={isAdditionalAttributeModalVisible}
          attributes={selectedAdditionalAttribute}
          onChange={onAdditionalAttributeChange}
          onClose={onFillAdditionalAttributeModalClose}
          attribute={selectedFieldName}
        />
      )}
    </Box>
  );
};
export default CreateSupplier;

